/*
 * @Author: luxiangying3
 * @Date: 2020-10-15
 * @LastEditTime: 2020-10-21 18:09:08
 * @Description: 存放根getters
 */
// 应用角色
export const appId = state => state.appId

// 管理者
export const isAdmin = state => state.isAdmin

// routeName
export const curRouteName = state => state.curRouteName

// appFlag
export const appFlag = state => state.appFlag
